import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8wc7yrktuq: FaireBrandEntity = {
  token: "b_8wc7yrktuq",
  type: "brand",
  name: "Wonderfully Made",
  avatarUrl:
    "https://cdn.faire.com/fastly/df82fe1e96056feb84a653bf14a6b90a8c1c65170458a1bd226815ef14cf2668.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b8ccf914f4f3455dccc146ee63681e127f25d87e4286bca72fd66d8941be7f9a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/df82fe1e96056feb84a653bf14a6b90a8c1c65170458a1bd226815ef14cf2668.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b8ccf914f4f3455dccc146ee63681e127f25d87e4286bca72fd66d8941be7f9a.png",
  location: "Eureka Springs, AR, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 54,
  isInsider: true,
  description:
    "Wonderfully Made was born from my deep desire to stay at home with my children. When I became a mother, I wanted to stay at home and raise my babies... and I couldn't. So I began to build Wonderfully Made. I clipped coupons, babysat, potty trained and ran a cash register, read bedtime stories, then made outfits long into the night.  The beautiful thing about this is that the Lord  abundantly blessed this work. Today, Wonderfully Made employs over 18 people, many of these being stay at home moms raising their babies. Each outfit you order, every accessory that is made, much of it comes from the hands and home of mothers raising their children right here in the United States. \n\nNow, just to say, I have several full time, work from my home moms who are completely amazing and choose the full time route because it fits their family dynamic well. And that is also part of the beauty of it, isn't it? We get to choose. \n\nOur mission here is to make a beautiful and quality product for newborns and babies, while supporting and changing the lives of the families who make it. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:59.932Z",
    importedBy: "entity-db-cli",
  },
};
